export function setAppTitle(title: string) {
  if (!document) return;

  document.title = `${title} - TVD`;
}
